{
  "global.siteDescription": "Preséntate en 30 segundos para que los demás te conozcan enseguida.",
  "global.languageSwitch": "Cambiar idioma",
  "global.languageCurrent": "Idioma actual: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "Cerrar",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.manage": "Administrar",
  "common.login": "Iniciar sesión",
  "common.logout": "Cerrar sesión",
  "common.loggingOut": "Cerrando sesión",
  "common.logoutRetry": "Reintentar cerrar sesión",
  "common.preview": "Vista previa",
  "common.email": "Email",
  "common.inviteCode": "Código de invitación",
  "common.loading": "Cargando",
  "editor.publish.processing": "Todavía se está procesando",
  "common.localDraft": "Borrador local",
  "common.publicBeta": "Beta pública",
  "common.serviceStatus": "Estado del servicio",
  "common.optional": "Opcional",
  "common.page": "Página",
  "common.reason": "Razón",
  "common.description": "Detalles",
  "common.submit": "Enviar",
  "nav.login": "Iniciar sesión",
  "nav.draftFirst": "Iniciar un borrador",
  "home.action.create": "Crear mi presentación",
  "home.action.continue": "Seguir escribiendo",
  "home.action.manage": "Gestionar mi presentación",
  "home.action.agent": "Agent escribe por ti",
  "home.meta.title": "30s.to — 30 segundos para conocerte.",
  "home.meta.description": "Cuando avanzas por tu cuenta, darte a conocer importa aún más. 30 segundos para conocerte. Quién eres, qué estás haciendo, qué has hecho y qué recursos puedes ofrecer. Ayuda a los demás a descubrir qué les interesa y conectar contigo.",
  "home.title": "30 segundos\npara conocerte.",
  "home.freeNote": "Crea, publica y comparte. Gratis para siempre.",
  "home.kicker": "Cuando avanzas por tu cuenta, darte a conocer importa aún más.",
  "home.value.copy": "Quién eres, qué estás haciendo, qué has hecho y qué recursos puedes ofrecer. Ayuda a los demás a descubrir qué les interesa y conectar contigo.",
  "home.features.label": "Características",
  "home.features.time.tab": "Leer en 30 segundos",
  "home.why.copy": "Escribe solo lo más importante. Cuanto más larga es la presentación, menos personas la terminan. 30 segundos es lo justo.",
  "home.principle.expression.title": "Exprésate libremente",
  "home.principle.expression.copy": "Organiza tu experiencia, tus trabajos, ideas y recursos a tu manera. Comparte lo que quieres que los demás sepan de ti.",
  "home.principle.link.title": "Tu propio enlace de 30s.to",
  "home.principle.link.copy": "30s.to/@you es corto, fácil de recordar y directo: conocerte en 30 segundos.",
  "home.principle.theme.title": "Exprésate con distintos temas",
  "home.principle.theme.copy": "Limpio, retro o atrevido y vibrante. Elige un tema que vaya contigo y deja que tu estilo se vea desde el primer vistazo.",
  "home.footer.tagline": "Di menos para que destaque lo importante.",
  "home.footer.navigation": "Navegación de pie de página",
  "home.demo.linkNotice": "Este es un enlace de demostración. Crea tu introducción de 30 segundos para agregar la tuya propia.",
  "home.demo.profile.name": "Maya Chen",
  "home.demo.profile.identity": "Diseñador de productos independiente que convierte problemas complejos en productos simples",
  "home.demo.profile.tag.product": "Diseño de producto",
  "home.demo.profile.tag.indie": "Productos independientes",
  "home.demo.profile.tag.ai": "Herramientas AI",
  "home.demo.profile.body": "## Ahora\nCreo Briefly para que los diseñadores independientes dediquen menos tiempo a mover notas y más a entender a las personas. Antes de diseñar, recorro la tarea real con un usuario.\n\n## Mi trayectoria\n2020–2023: diseño del editor y la incorporación de usuarios en un equipo de software colaborativo. Con ingeniería, dividí operaciones complejas en pasos manejables.\n\nDesde 2024 trabajo de forma independiente: investigación y diseño de interacción para equipos nuevos, además de mis propios productos.\n\n## Proyectos\n- [Relay](https://example.com/projects/relay): diseñé este registro de decisiones que reúne conclusiones, motivos y responsables para dar contexto a quienes se incorporan.\n- [Briefly](https://example.com/projects/briefly): en una prueba pequeña, organiza entrevistas en temas rastreables y conserva citas originales para comprobar las interpretaciones.\n\n## Qué puedo aportar\nSi tienes comentarios pero no sabes qué cambiar primero, puedo ayudarte a definir el problema y crear un prototipo comprobable. Comparto guías de entrevistas y plantillas de notas con equipos que empiezan a investigar.\n\n## Hablemos\nQuiero conocer a quienes cuidan sus pequeños productos y hablar de primeras entrevistas, decisiones y trabajo independiente. Los fines de semana exploro tiendas del barrio: una lista de precios manuscrita puede enseñar mucho.",
  "home.demo.profile.link.website": "Portfolio",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "Reserva una charla",
  "handleStart.kicker": "URL pública",
  "handleStart.title": "Elige tu URL de 30s.to",
  "handleStart.copy": "Elige primero una URL fácil de recordar y después escribe tu presentación de 30 segundos. Conservaremos cualquier borrador que ya tengas.",
  "handleStart.label": "Tu URL",
  "handleStart.help.empty": "Entre 4 y 24 letras minúsculas. Ahora solo guardamos el borrador; comprobaremos la disponibilidad al publicar.",
  "handleStart.help.ok": "El formato es válido. Volveremos a comprobar la disponibilidad al publicar.",
  "handleStart.submit": "Continuar escribiendo",
  "handleAvailability.checking": "Comprobando esta URL…",
  "handleAvailability.available": "Está disponible. La URL será tuya cuando publiques correctamente.",
  "handleAvailability.owned": "Esta es la URL que tienes actualmente.",
  "handleAvailability.assigned": "Esta URL está asignada a ti y se activará cuando publiques.",
  "handleAvailability.failed": "No hemos podido comprobar esta URL. Inténtalo de nuevo.",
  "handleAvailability.rateLimited": "Demasiadas comprobaciones. Inténtalo de nuevo en {minutes} minutos.",
  "handleAvailability.retry": "Comprobar de nuevo",
  "handleAvailability.suggestions": "También puedes probar",
  "handleAvailability.cooldown": "La URL pública sigue dentro del periodo de espera de 30 días. Podrás cambiarla después del {date}; también puedes volver a la URL publicada actualmente.",
  "editor.shell.loading": "Cargando crear flujo",
  "editor.shell.workspace": "Espacio de trabajo de introducción de 30 segundos",
  "editor.shell.canvas": "Superficie de escritura de introducción de 30 segundos",
  "editor.command.aria": "Barra de comandos del editor",
  "editor.command.publish": "Publicar",
  "editor.command.publishUpdate": "Publicar cambios",
  "editor.command.publishSettings": "Configuración de publicación",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "Publicado",
  "editor.publish.successAfterLogin": "Iniciado sesión y publicado",
  "editor.publish.publishing": "Publicando…",
  "editor.publish.publishingDetail": "Estamos preparando tu página pública. Espera un momento.",
  "editor.publish.successDetail": "Tu página pública está actualizada y lista para verla.",
  "editor.publish.viewPublic": "Ver página pública",
  "editor.publish.cacheFailed": "pero falló al escribir el caché de la página pública.",
  "editor.command.login": "Acceso",
  "editor.handle.editTitle": "Editar dirección pública",
  "editor.handle.claimAfterPublish": "Tuyo después de publicar",
  "editor.handle.claimAfterPublishTitle": "Esta dirección pasa a ser suya después de la publicación.",
  "editor.status.signedIn": "Iniciado sesión",
  "editor.status.account": "Cuenta: {email}",
  "editor.status.localTitle": "Proyecto local",
  "editor.status.localCopy": "Este borrador solo se guarda en este dispositivo. Inicia sesión para sincronizarlo con la nube.",
  "editor.status.location": "Guardar ubicación",
  "editor.status.state": "Guardar estado",
  "editor.status.emailLogin": "Iniciar sesión en Email",
  "editor.autosave.savingShort": "Guardando",
  "editor.autosave.savedCloudShort": "Guardado en la nube",
  "editor.autosave.savedLocalShort": "Guardado localmente",
  "editor.autosave.failedShort": "Error al guardar",
  "editor.autosave.signedInShort": "Iniciado sesión",
  "editor.autosave.cloud": "Nube",
  "editor.autosave.retry": "Necesita volver a intentarlo",
  "editor.autosave.device": "este dispositivo",
  "editor.autosave.saving": "Guardado automático...",
  "editor.autosave.savedLocal": "Guardado automáticamente localmente",
  "editor.autosave.savedCloud": "Guardado automáticamente en la nube",
  "editor.autosave.authExpired": "La sesión expiró. Guardado localmente.",
  "editor.autosave.cloudFailed": "Error al guardar en la nube. Guardado localmente.",
  "editor.autosave.cloudUnavailable": "El guardado en la nube aún no está disponible. El borrador se ha guardado en este dispositivo.",
  "editor.autosave.failed": "Error al guardar automáticamente. Copie su contenido y vuelva a intentarlo.",
  "editor.autosave.enabled": "El guardado automático está activado",
  "identity.namePlaceholder": "Su nombre",
  "identity.nameAria": "Nombre o apodo",
  "identity.identityPlaceholder": "Identidad de una línea",
  "identity.identityAria": "Identidad de una línea",
  "identity.tagsAria": "Etiquetas",
  "identity.addTag": "Agregar etiqueta",
  "identity.removeTag": "Eliminar etiqueta {tag}",
  "body.emptyInstruction": "Escribe lo más importante que alguien debería saber al conocerte.\nEscribe menos para que se vea lo importante. 30 segundos, justo lo necesario.",
  "body.templatesLabel": "También puedes empezar con una plantilla",
  "body.templatesAria": "Plantillas de identidad para el texto",
  "body.templateExampleLabel": "Perfil de ejemplo",
  "body.viewTemplateExample": "Ver ejemplo",
  "links.sectionAria": "Campo de golf",
  "links.documentTitle": "Campo de golf",
  "links.documentCopy": "Perfiles sociales, reservas y datos de contacto.",
  "links.documentEmptyCopy": "Agregue un perfil social, una página de reserva o un método de contacto. Puedes cambiarlos en cualquier momento.",
  "links.add": "Agregar enlace",
  "links.addType": "Añadir {label}",
  "links.edit": "Editar {label}",
  "links.addedAria": "Enlaces añadidos",
  "links.closePanel": "Cerrar editor de enlaces",
  "links.editTitle": "Editar enlace",
  "links.addTitle": "Agregar enlace",
  "links.chooseTypeAgain": "Elija el tipo de enlace nuevamente",
  "links.calendarProvider": "Proveedor de reservas",
  "links.displayName": "Nombre para mostrar",
  "links.duplicate": "Ya se ha agregado {label}.",
  "links.alreadyAdded": "{label} ya agregado",
  "links.bookingAlreadyAdded": "La reserva ya ha sido agregada.",
  "links.remove": "Borrar",
  "links.category.social": "Social",
  "links.category.booking": "Reserva",
  "links.category.work": "Trabajos / sitios web",
  "links.category.content": "Contenido",
  "links.category.contact": "Contacto",
  "links.category.other": "Otro",
  "links.type.x": "incógnita",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "Xiaohongshu",
  "links.type.wechat": "Cuenta oficial de WeChat",
  "links.type.email": "Email",
  "links.type.calendar": "Reserva",
  "links.type.website": "Sitio web",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "broma",
  "links.type.other": "Otro",
  "links.input.x": "Usuario de X",
  "links.input.github": "Mango GitHub",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Mango Instagram",
  "links.input.youtube": "Mango YouTube",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Perfil de Xiaohongshu URL",
  "links.input.wechat": "ID de cuenta oficial de WeChat",
  "links.input.email": "Email",
  "links.input.calendar": "Ruta de reserva",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "Mango TikTok",
  "links.input.threads": "Mango Threads",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Mango Dribbble",
  "links.input.jike": "Perfil Jike URL",
  "links.input.other": "Enlace URL",
  "links.input.calendar.cal": "Ruta de Cal.com",
  "links.input.calendar.calendly": "camino calendario",
  "links.input.calendar.google": "Página de reservas Google Calendar",
  "links.input.calendar.microsoft": "Enlace Microsoft Bookings",
  "links.input.calendar.hubspot": "Enlace HubSpot Meetings",
  "links.input.calendar.savvycal": "Ruta SavvyCal",
  "links.input.calendar.tidycal": "Ruta TidyCal",
  "links.input.calendar.zcal": "camino zcal",
  "links.hint.handle": "Ingrese solo el identificador, no un URL.",
  "links.hint.uid": "Ingrese solo el UID, no el perfil URL.",
  "links.hint.slug": "Introduzca sólo la ruta, no el URL completo.",
  "links.hint.email": "Esto crea un enlace de correo.",
  "links.hint.text": "Al hacer clic en la página pública se copia este valor.",
  "links.hint.url": "Ingrese un enlace https:// válido para esta plataforma.",
  "links.hint.calendarSlug": "Ingrese solo el nombre de usuario o la ruta de reserva, no el URL completo.",
  "links.hint.calendarUrl": "Ingrese a la página de reservas completa URL para esta plataforma.",
  "rich.toolbarAria": "Barra de herramientas de formato de texto",
  "rich.heading": "Título de sección",
  "rich.paragraph": "Párrafo",
  "rich.bold": "Atrevido",
  "rich.boldFallback": "texto en negrita",
  "rich.italic": "Itálico",
  "rich.italicFallback": "texto en cursiva",
  "rich.code": "código en línea",
  "rich.comment": "Alternar comentario",
  "rich.ul": "Lista con viñetas",
  "rich.ol": "lista numerada",
  "rich.link": "Enlace",
  "rich.linkPrompt": "Ingrese un enlace https:// o mailto:",
  "rich.linkInvalid": "Los enlaces solo admiten https:// o mailto:",
  "rich.linkFallback": "texto del enlace",
  "rich.aria": "Cuerpo de introducción de 30 segundos",
  "rich.more": "Más formatos",
  "rich.quote": "Cita",
  "rich.strikethrough": "Tachado",
  "rich.strikethroughFallback": "texto tachado",
  "rich.codeBlock": "Bloque de código",
  "rich.codeBlockFallback": "código",
  "rich.taskList": "Lista de tareas",
  "rich.table": "Tabla",
  "rich.tableSkeleton": "| Elemento | Descripción |\n| --- | --- |\n| Elemento uno | Descripción uno |\n| Elemento dos | Descripción dos |",
  "rich.indent": "Aumentar sangría",
  "rich.outdent": "Reducir sangría",
  "rich.placeholder": "Escribe una introducción Markdown que se pueda leer en 30 segundos...",
  "feedback.aria": "Escribir comentarios",
  "feedback.timeTitle": "Tiempo estimado de lectura",
  "feedback.preview": "Avance",
  "feedback.previewMenu": "Abrir menú de vista previa",
  "feedback.openAcceptancePreview": "Abrir vista previa de aceptación",
  "feedback.acceptancePreviewCopy": "Ver el resultado de la página pública en este dispositivo",
  "feedback.noIssues": "Sin problemas de bloqueo",
  "feedback.prePublish": "Comprobaciones previas a la publicación",
  "feedback.ready": "Sin bloqueadores",
  "feedback.itemCount": "Artículos {count}",
  "feedback.valid": "El contenido pasa los controles de publicación.",
  "issue.action.displayName": "Agregar nombre",
  "issue.action.oneLineIdentity": "Agregar identidad",
  "issue.action.tags": "Agregar etiquetas",
  "issue.action.body": "Volver al texto",
  "issue.action.handle": "Elige dirección",
  "issue.action.links": "Administrar enlaces",
  "issue.action.view": "Vista",
  "issue.short.displayName": "Nombre faltante",
  "issue.short.oneLineIdentity": "Identidad perdida",
  "issue.short.tags": "Etiquetas faltantes",
  "issue.short.handle": "dirección faltante",
  "issue.short.readingTime": "Más de 60 s",
  "issue.short.readingTimeLong": "Más de 30 s",
  "issue.short.readingTimeShort": "Muy poco contenido",
  "issue.short.bodyPlaceholder": "Contenido de ejemplo en el texto",
  "issue.short.bodyFormat": "Formato del texto",
  "issue.short.links": "Problema de enlace",
  "issue.short.linksEmpty": "Se pueden agregar enlaces",
  "issue.short.pending": "necesita trabajo",
  "issue.summary.more": "Elementos {count} para arreglar",
  "publish.title.create": "Confirmar publicación",
  "publish.title.update": "Confirmar cambios",
  "publish.action.create": "Publicar en 30s.to",
  "publish.action.update": "Publicar cambios",
  "publish.closeAria": "Cerrar confirmación de publicación",
  "publish.address": "megafonía",
  "publish.unpublishedChanges": "Cambios no publicados",
  "publish.handleChanged": "Tu dirección cambiará de @{oldHandle} a @{newHandle}. La anterior redirigirá durante 30 días. A los 180 días del cambio podrá asignarse a otra persona y los enlaces antiguos podrán mostrar su perfil.",
  "publish.readingTime": "tiempo de lectura",
  "publish.status": "Estado",
  "publish.ready": "Listo",
  "publish.todo": "{count} elementos para mejorar",
  "publish.visibility": "Forma de publicación",
  "publish.visibility.indexed": "Permitir indexación en buscadores",
  "publish.visibility.unlisted": "Acceso por enlace",
  "publish.visibility.indexedNote": "Cualquiera puede verla y puede aparecer en los resultados de búsqueda.",
  "publish.visibility.unlistedNote": "Cualquiera con el enlace puede verla; no la enviaremos a los buscadores.",
  "publish.visibility.publicNote": "Ambas opciones son públicas y el enlace se puede reenviar. Déjala como borrador si solo tú debes verla.",
  "publish.publicContent": "Al publicar, tu nombre, identidad, etiquetas, texto y enlaces serán públicos. Los comentarios de autor no se muestran, pero no deben contener secretos.",
  "publish.noop": "La página pública ya está actualizada. Cambie el contenido o la visibilidad antes de volver a publicar.",
  "publish.valid": "El contenido pasa los controles de publicación.",
  "handleEdit.title": "Editar dirección pública",
  "handleEdit.label": "Dirección 30s.to",
  "handleEdit.help.changed": "Guardar solo modifica el borrador. Al publicar, la dirección anterior redirigirá durante 30 días y podrá reasignarse a los 180 días.",
  "handleEdit.help.saved": "Guardado en borrador. La disponibilidad se comprueba nuevamente al publicar.",
  "handleEdit.note": "La dirección pública actual sigue siendo 30s.to/@{handle}. La nueva dirección entra en vigor después de la publicación.",
  "handleEdit.save": "Guardar en borrador",
  "conflict.title": "Elija la versión borrador",
  "conflict.copy": "Tanto este dispositivo como la nube tienen contenido inédito. Su elección se convierte en la próxima versión para editar.",
  "conflict.useLocal": "Usar borrador local",
  "conflict.useLocalCopy": "Mantenga el contenido de la página actual y sincronícelo con la nube.",
  "conflict.useCloud": "Usar borrador en la nube",
  "conflict.untitled": "Intitulado",
  "conflict.cloudVersion": "Versión guardada en la nube",
  "conflict.modifiedAt": "Última edición · {time}",
  "conflict.time.justNow": "ahora mismo",
  "conflict.time.minutesAgo": "hace {count} min",
  "conflict.time.hoursAgo": "hace {count} h",
  "conflict.time.daysAgo": "hace {count} días",
  "authModal.title": "Inicie sesión en 30s.to",
  "authModal.copy": "Después de iniciar sesión, los borradores se sincronizan con la nube y la publicación es más confiable.",
  "login.page.eyebrow": "Cuenta",
  "login.page.title": "Inicie sesión en 30s.to",
  "login.page.copy": "Sincronice borradores, publique páginas públicas y administre invitaciones.",
  "login.invalidEmail": "Ingrese un correo electrónico válido.",
  "login.sendFailed": "No se pudo enviar el código.",
  "login.devCodeReady": "Código de desarrollo local generado.",
  "login.codeSent": "Código enviado. Revisa tu correo electrónico.",
  "login.networkSendFailed": "No se pudo enviar el código. Comprueba tu conexión.",
  "login.invalidCode": "Ingrese el código de 6 dígitos.",
  "login.codeInvalid": "El código es incorrecto o ha caducado.",
  "login.failed": "Error de inicio de sesion. Vuelve a intentarlo más tarde.",
  "login.sendBusy": "Envío...",
  "login.resendCode": "Reenviar código",
  "login.sendCode": "Enviar código",
  "login.localCode": "Código de desarrollo local: {code}",
  "login.code": "Código",
  "login.codePlaceholder": "6 dígitos",
  "login.inviteHelp": "La Beta pública requiere un código de invitación. La verificación activa su cuenta.",
  "login.verifyBusy": "Verificando...",
  "login.verifyInvite": "Verificar invitación e iniciar sesión",
  "login.verify": "Inicia sesión y continúa",
  "login.footnote": "Inicio de sesión sin contraseña. Los nuevos usuarios se activan con una invitación después de la verificación por correo electrónico.",
  "login.google": "Continuar con Google",
  "login.github": "Continuar con GitHub",
  "login.emailDivider": "o usar el correo electrónico",
  "login.oauthFailed": "El inicio de sesión social no finalizó. Inténtalo de nuevo o utiliza el inicio de sesión por correo electrónico.",
  "login.linkTitle": "Verificar cuenta de correo electrónico",
  "login.linkPageCopy": "Una cuenta 30s.to ya utiliza este correo electrónico. Lo vinculamos sólo después de la verificación; las cuentas nunca se fusionan automáticamente.",
  "login.linkCopy": "Enviaremos un código a {email}. El correo electrónico no se puede cambiar aquí.",
  "login.linkVerify": "Verificar y vincular",
  "login.linkRequired": "Se encontró una cuenta existente. Verifica su correo electrónico para continuar.",
  "login.activateTitle": "Activar 30s.to",
  "login.activatePageCopy": "Su identidad social está verificada. No se crea ninguna cuenta permanente hasta que la invitación se realice correctamente.",
  "login.activateCopy": "La Beta pública requiere una invitación. Se canjea únicamente cuando la creación de la cuenta se realiza correctamente.",
  "login.activationOpenCopy": "El registro está abierto. Continúa para activar tu cuenta.",
  "login.activationClosedCopy": "La activación de nuevas cuentas está pausada. Las cuentas existentes aún pueden iniciar sesión.",
  "login.activate": "Activar y continuar",
  "login.inviteRequired": "Email verificado. Utilice una invitación para activar.",
  "login.useEmailInstead": "Utilice el inicio de sesión por correo electrónico en su lugar",
  "preview.emptyEyebrow": "Avance",
  "preview.emptyTitle": "No hay introducción disponible para obtener una vista previa.",
  "preview.backToEdit": "Volver a editar",
  "preview.edit": "Editar",
  "preview.localNoteAria": "Nota de vista previa local",
  "preview.localNote": "Aceptación local",
  "preview.localTitle": "Vista previa del borrador en este dispositivo",
  "preview.themePicker": "Cambiador de temas",
  "preview.themeGroup": "Elige tema",
  "preview.themeFree": "Base",
  "preview.themePro": "Pro",
  "preview.mobileAria": "Vista previa de la página pública móvil",
  "preview.close": "Cerrar vista previa",
  "preview.editorTitle": "Avance",
  "preview.publicTitle": "Vista previa de la página pública",
  "preview.shareCardButton": "Ver tarjeta temática",
  "preview.shareCardDialogTitle": "Vista previa de la tarjeta temática",
  "preview.shareCardTitle": "Tarjeta temática {theme}",
  "preview.shareCardLogin": "Inicia sesión para renderizar la vista previa real",
  "preview.shareCardLoading": "Representando la tarjeta temática...",
  "preview.shareCardError": "La vista previa de la tarjeta no está disponible temporalmente",
  "preview.shareCardNote": "La tarjeta temática utiliza el mismo lenguaje visual que la página pública. Las tarjetas universales están disponibles en Dashboard.",
  "public.copySuccess": "Copiado {label}",
  "public.copyFailed": "La copia falló. Copie manualmente.",
  "public.createMine": "crear mi introducción",
  "public.report": "Reportar esta página",
  "public.ownerAria": "Entrada de gestión personal",
  "public.owner.manage": "Administrar",
  "public.owner.edit": "Editar",
  "public.status.unavailable": "Indisponible",
  "public.status.notFound": "404",
  "public.status.moderated": "Esta introducción de 30 segundos no está disponible.",
  "public.status.frozen": "Esta dirección pública no está disponible.",
  "public.status.unpublished": "Esta introducción de 30 segundos aún no se ha publicado.",
  "theme.footer": "Hecho con 30s.to",
  "theme.fallback.name": "Su nombre",
  "theme.fallback.nameUpper": "SU NOMBRE",
  "theme.fallback.nameNoir": "Nombre",
  "theme.fallback.nameIndex": "Juan Pérez",
  "theme.fallback.identity": "¿A qué te dedicas?",
  "theme.fallback.identityUpper": "SU IDENTIDAD Y MISIÓN DE UNA LÍNEA",
  "theme.fallback.identityIndex": "Desconocido",
  "theme.fallback.identityNoir": "Identidad",
  "theme.fallback.terminalName": "invitado",
  "theme.fallback.terminalIntro": "Aún no hay una breve introducción",
  "theme.terminal.commandLabel": "comando terminal",
  "theme.terminal.commandSubmit": "Ejecutar comando",
  "theme.terminal.outputLabel": "Salida de terminal interactiva",
  "theme.connect": "CONECTAR",
  "theme.markdown.tableRegion": "Tabla de contenido, desplazable horizontalmente",
  "theme.markdown.task": "Tarea",
  "theme.tags": "ETIQUETAS",
  "theme.verified": "VERIFICADO",
  "theme.name": "NOMBRE",
  "theme.identityLabel": "IDENTIDAD",
  "theme.keywords": "PALABRAS CLAVE",
  "theme.scroll": "Voluta",
  "theme.pixel.previous": "Pantalla anterior",
  "theme.pixel.next": "Siguiente pantalla",
  "theme.pixel.screen": "Pantalla {current} de {total}",
  "theme.arcade.stage": "Etapa {current} / {total}",
  "theme.noise.reseed": "Ruido de resiembra",
  "theme.readingTime": "{seconds} s de lectura",
  "theme.readingUnit": "s de lectura",
  "theme.letter.greeting": "Hola:",
  "theme.letter.signoff": "Un saludo,",
  "theme.letter.postscript": "Puedes encontrarme aquí",
  "theme.letter.written": "Escrito el {date}",
  "dashboard.loginTitle": "Inicia sesión para administrar tu introducción.",
  "dashboard.loginAction": "Iniciar sesión y gestionar",
  "dashboard.bannedTitle": "Esta cuenta no está disponible actualmente.",
  "dashboard.bannedCopy": "Si cree que se trata de un error, contáctenos a través de la entrada de informe y apelación.",
  "connections.kicker": "Cuenta",
  "connections.title": "Métodos de inicio de sesión",
  "connections.settingsKicker": "Configuración",
  "connections.settingsTitle": "Cuenta y conexiones",
  "connections.settingsCopy": "Gestiona las identidades de inicio de sesión y el acceso de Agents de terceros.",
  "connections.backToDashboard": "Volver al panel",
  "connections.emailCode": "Código de verificación por correo",
  "connections.alwaysAvailable": "Siempre disponible",
  "connections.connect": "Conectar",
  "connections.disconnect": "Eliminar enlace 30s.to",
  "connections.notConnected": "No conectado",
  "connections.noEmail": "No se proporcionó ningún correo electrónico",
  "connections.emailVerified": "Email verificado",
  "connections.connected": "Conectado",
  "connections.unavailable": "No habilitado",
  "connections.confirm": "¿Eliminar el enlace {provider} de 30s.to? El inicio de sesión de Email permanece disponible.",
  "connections.removed": "El enlace de identidad se eliminó de 30s.to.",
  "connections.failed": "No se pudieron actualizar los métodos de inicio de sesión. Vuelve a intentarlo más tarde.",
  "connections.help": "Esto sólo elimina la asignación de identidad 30s.to; no revoca el acceso del proveedor. Administrar el acceso del proveedor:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Conexiones de Agent",
  "agentConnections.copy": "Instala una sola Skill para que tus Agents habituales recopilen información, redacten y actualicen de forma segura tu borrador de 30s.to.",
  "agentConnections.addTitle": "Conectar un Agent nuevo",
  "agentConnections.addCopy": "Ver la URL de conexión y los pasos de configuración",
  "agentConnections.examplesDisclosure": "Ver ejemplos de uso",
  "settings.title": "Configuración",
  "settings.copy": "Gestiona tu cuenta, la seguridad, las conexiones externas y el plan de 30s.to.",
  "settings.navAria": "Categorías de configuración",
  "settings.account.title": "Cuenta",
  "settings.account.copy": "Tu identidad en 30s.to y el acceso a tu perfil.",
  "settings.account.email": "Correo de la cuenta",
  "settings.account.profile": "Perfil",
  "settings.account.plan": "Plan actual",
  "settings.account.manageProfile": "Gestionar perfil",
  "settings.login.copy": "Gestiona las identidades que puedes usar para iniciar sesión en 30s.to.",
  "settings.billing.copy": "Consulta tu plan actual, el estado de renovación y el acceso a la facturación.",
  "settings.invites.copy": "Gestiona tu cupo de invitaciones de Public Beta y los códigos recientes.",
  "agentConnections.endpoint": "URL de conexión",
  "agentConnections.copyAction": "Copiar",
  "agentConnections.copied": "Copiado",
  "agentConnections.copyFailed": "No se pudo copiar. Copia la URL manualmente.",
  "agentConnections.endpointCopied": "URL de conexión copiada.",
  "agentConnections.stepsAria": "Pasos para conectar un Agent",
  "agentConnections.step1": "Añade un servicio remoto en la configuración de MCP o conectores de tu Agent.",
  "agentConnections.step2": "Pega la URL de conexión, inicia sesión en 30s.to y autoriza el acceso.",
  "agentConnections.step3": "Dile al Agent qué debe cambiar y vuelve a 30s.to para revisar el borrador.",
  "agentConnections.examplesTitle": "Prueba a pedir",
  "agentConnections.exampleFirst": "Lee mi perfil de 30s.to y sus reglas de formato, y ayúdame a completar mi primera presentación.",
  "agentConnections.exampleSection": "Mantén mi tono y reescribe solo la sección «Ahora».",
  "agentConnections.exampleShorten": "Reduce toda la presentación para que se lea en menos de 30 segundos. No la publiques.",
  "agentConnections.copyExample": "Copiar ejemplo {number}",
  "agentConnections.promptCopied": "Instrucción de ejemplo copiada.",
  "agentConnections.boundary": "Los Agents solo pueden leer y actualizar borradores. No pueden publicar ni dejar de publicar por ti.",
  "agentConnections.authorizedTitle": "Conexiones autorizadas",
  "agentConnections.empty": "Aún no has autorizado ningún Agent.",
  "agentConnections.disabled": "Las conexiones de Agent aún no están habilitadas.",
  "agentConnections.scopeRead": "Leer borrador",
  "agentConnections.scopeWrite": "Actualizar borrador",
  "agentConnections.connectedAt": "Conectado el {date}",
  "agentConnections.selfReported": "El nombre del cliente lo declara el propio cliente",
  "agentConnections.revoke": "Revocar",
  "agentConnections.confirm": "¿Revocar la conexión con {client}? Ya no podrá acceder a tu borrador de 30s.to.",
  "agentConnections.confirmSkill": "¿Revocar la conexión de 30s.to Skill? Los Agents locales que usen esta Skill cerrarán sesión en 30s.to.",
  "agentConnections.revoked": "Conexión de Agent revocada.",
  "agentConnections.failed": "No se pudieron actualizar las conexiones de Agent. Inténtalo más tarde.",
  "agentConnections.manualTitle": "Conectar Remote MCP manualmente",
  "agentConnections.manualCopy": "Opción avanzada: autoriza por separado un cliente compatible con Remote MCP",
  "skill.meta.title": "30s.to Skill — Deja que tu Agent escriba tu presentación",
  "skill.meta.description": "Comparte tu web, tus proyectos o tu portafolio. Agent investiga tu trabajo y te entrevista para escribir tu presentación de 30 segundos.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "Tu presentación,\ncon ayuda de tu agente.",
  "skill.copy": "Dale unos enlaces. Tu agente te conoce y te ayuda a escribir una presentación que se lee en 30 segundos.",
  "skill.processTitle": "Cómo te ayuda a escribir",
  "skill.process.clues.title": "Comparte enlaces",
  "skill.process.clues.copy": "Tu perfil público, la web de tu proyecto o tu portafolio.",
  "skill.process.research.title": "Investiga a fondo y te entrevista",
  "skill.process.research.copy": "Investiga a fondo tu web, tus proyectos y tu trabajo, organiza lo esencial y después te entrevista para completar lo que falta.",
  "skill.process.profile.title": "Agent escribe tu presentación",
  "skill.process.profile.copy": "Ajustáis juntos el contenido y el tono hasta que sientas que te representa.",
  "skill.installTitle": "Instálala en tu Agent",
  "skill.installCopy": "Copia las instrucciones, pégalas en tu agente habitual y envíalas.",
  "skill.promptLabel": "Instrucción de instalación",
  "skill.copyPrompt": "Copiar instrucción de instalación",
  "skill.promptCopied": "Instrucción de instalación copiada. Ahora abre el Agent que utilizas, pega la instrucción y envíala.",
  "skill.copyFailed": "No se pudo copiar. Selecciona y copia la instrucción de instalación de abajo.",
  "skill.startTitle": "Cómo empezar",
  "skill.start.install": "Instala la Skill de 30s.to",
  "skill.start.chat": "Empieza a conversar",
  "skill.start.chatCopy": "Tras instalarla, abre una conversación nueva y dile:",
  "skill.start.prompt": "Ayúdame a escribir mi presentación con 30s.to.",
  "dashboard.kicker": "mi introducción",
  "dashboard.defaultTitle": "Mi introducción de 30 segundos.",
  "dashboard.primaryEdit": "Continuar editando",
  "dashboard.primaryCreate": "Empezar a crear",
  "dashboard.unpublished": "No publicado",
  "dashboard.unselected": "No seleccionado",
  "dashboard.confirmDiscard": "¿Descartar cambios no publicados y restaurar la versión pública actual?",
  "dashboard.discardFailed": "No se pudieron descartar los cambios.",
  "dashboard.discardConflict": "Este borrador cambió en otro lugar. Actualiza la página y revísalo antes de intentarlo de nuevo.",
  "dashboard.discardNetworkFailed": "No se pudieron descartar los cambios. Vuelve a intentarlo más tarde.",
  "dashboard.discardDone": "Restaurado a la versión pública actual.",
  "dashboard.statusAria": "Estado actual",
  "dashboard.versionAria": "Relación de versión",
  "dashboard.publicPage": "pagina publica",
  "dashboard.indexingAllowed": "Indexación permitida",
  "dashboard.indexingBlocked": "Acceso por enlace",
  "dashboard.publicVersion": "Versión publicada",
  "dashboard.invisible": "Aún no visible para los demás",
  "dashboard.draft": "Borrador",
  "dashboard.currentDraft": "Versión editable actual",
  "dashboard.draftSynced": "Sincronizado con la página pública.",
  "dashboard.editableVersionEmpty": "Versión editable · No creada",
  "dashboard.editableVersionDirty": "Versión editable · Cambios no publicados",
  "dashboard.editableVersionSynced": "Versión editable · Coincide con la página pública",
  "dashboard.editableVersionUnpublished": "Versión editable · No publicada",
  "dashboard.betaActive": "Activo",
  "dashboard.betaInactive": "Inactivo",
  "dashboard.adminCanPublish": "La cuenta de administrador puede publicar",
  "dashboard.betaAccessNote": "Acceso a publicación Beta pública",
  "dashboard.visibility": "Visibilidad",
  "dashboard.chooseOnPublish": "Elija durante la confirmación de publicación",
  "dashboard.snapshot": "Instantánea",
  "dashboard.snapshotAfterPublish": "La instantánea de la página pública se genera después de la publicación.",
  "dashboard.publishDetailsAria": "Detalles de publicación",
  "dashboard.actionsAria": "Acciones de gestión",
  "dashboard.nextAction": "Siguiente paso",
  "dashboard.openPublicPage": "Abrir página pública",
  "dashboard.changeVisibility": "Cambiar forma de publicación",
  "dashboard.unpublish": "Dejar de publicar",
  "dashboard.unpublishTitle": "¿Dejar de publicar?",
  "dashboard.unpublishDescription": "La página pública dejará de estar disponible de inmediato. Conservaremos el borrador y la dirección pública para que puedas volver a publicarla.",
  "dashboard.unpublishWarning": "Las copias guardadas por buscadores u otras personas pueden no desaparecer de inmediato.",
  "dashboard.unpublishConfirm": "Dejar de publicar",
  "dashboard.unpublishBusy": "Deteniendo...",
  "dashboard.unpublishSuccess": "La página pública ya no está disponible. Se conservaron el borrador y la dirección pública.",
  "dashboard.unpublishFailed": "No se pudo dejar de publicar. Inténtalo más tarde.",
  "dashboard.discardBusy": "Restaurando...",
  "dashboard.discard": "Descartar cambios",
  "dashboard.metricsAria": "Datos ligeros",
  "dashboard.views": "Vistas",
  "dashboard.clicks": "Clics",
  "dashboard.readingTime": "tiempo de lectura",
  "dashboard.theme": "Tema",
  "dashboard.noTheme": "No seleccionado",
  "dashboard.visibility.indexed": "Permitir indexación en buscadores",
  "dashboard.visibility.unlisted": "Acceso por enlace",
  "dashboard.visibility.indexedNote": "Puede aparecer en los resultados de búsqueda",
  "dashboard.visibility.unlistedNote": "Sigue visible para cualquiera con el enlace directo",
  "dashboard.snapshot.ready": "Caché listo",
  "dashboard.snapshot.failed": "respaldo D1",
  "dashboard.snapshot.none": "No generado",
  "dashboard.snapshot.readyNote": "Instantánea pública escrita en KV",
  "dashboard.snapshot.failedNote": "La página pública todavía funciona a través del respaldo D1",
  "dashboard.snapshot.noneNote": "No hay ninguna instantánea disponible para la versión publicada actual",
  "invite.title": "Invitar amigos a la Beta Pública",
  "invite.remaining": "Quedan invitaciones {remaining} / {quota} este mes.",
  "invite.generateFailed": "No se pudo generar la invitación.",
  "invite.generated": "Se generaron {count} códigos de invitación. Solo se muestran esta vez.",
  "invite.quotaUsed": "Cuota de invitación mensual utilizada.",
  "invite.generating": "Generando...",
  "invite.generate": "Generar los {count} restantes",
  "invite.batchTitle": "{count} códigos generados ahora",
  "invite.copyAll": "Copiar todos los códigos",
  "invite.copiedAll": "Todos los códigos copiados",
  "invite.copyMessage": "Copiar mensaje",
  "invite.messageCopied": "Mensaje copiado",
  "invite.share": "Compartir",
  "invite.shared": "Se abrió el panel para compartir.",
  "invite.shareFallback": "No se puede compartir directamente; se copió el mensaje.",
  "invite.shareFailed": "No se pudo compartir. Copia el mensaje en su lugar.",
  "invite.shareMessage": "Estoy usando 30s.to para crear una presentación personal de 30 segundos. Te invito a probarlo.\n\nCódigos de invitación:\n{codes}\n\nAbre {url} para empezar.",
  "invite.recentAria": "Estado de uso de las invitaciones",
  "invite.statusTitle": "Estado de uso",
  "invite.statusSummary": "{active} disponibles · {redeemed} usados · {expired} vencidos · {revoked} revocados",
  "invite.status.revoked": "Revocado",
  "invite.status.redeemed": "Usado",
  "invite.status.expired": "Venció",
  "invite.status.active": "Disponible",
  "invite.copy": "Copiar",
  "invite.copied": "Copiado",
  "invite.showOnce": "Mostrado solo una vez",
  "invite.expiryUnknown": "Caducidad desconocida",
  "invite.expiresAt": "Vence el {date}",
  "management.handlePending.title": "Cambio de dirección pendiente",
  "management.handlePending.description": "La dirección pública actual sigue siendo {publishedAddress}. La publicación activa {draftAddress}.",
  "management.handlePending.next": "Publique los cambios antes de que {draftAddress} se convierta en la dirección pública.",
  "management.dirty.title": "Cambios no publicados",
  "management.dirty.description": "Su borrador no ha sido publicado en la página pública.",
  "management.dirty.next": "Publique cambios para sincronizar la página pública con este borrador.",
  "management.published.title": "Publicado",
  "management.published.description": "La página pública está actualizada.",
  "management.published.next": "La página pública está sincronizada. Continúe editando cuando desee ajustarlo.",
  "management.unpublished.title": "Inédito",
  "management.unpublished.description": "Esta introducción todavía solo se guarda como borrador.",
  "management.unpublished.next": "Publíquelo antes de que otros puedan visitar la dirección pública.",
  "management.empty.title": "Aún no hay introducción",
  "management.empty.description": "Elija una dirección y escriba una introducción de 30 segundos.",
  "management.empty.next": "Primero crea un borrador. Los controles previos a la publicación permanecen en el editor.",
  "management.publish.create": "Publicar introducción",
  "management.publish.update": "Publicar cambios",
  "abuse.kicker": "Confianza y seguridad",
  "abuse.title": "Página de informe",
  "abuse.copy": "Los informes se utilizan únicamente para revisión de seguridad. Tu identidad no es pública.",
  "abuse.missingHandle": "Objetivo de informe faltante.",
  "abuse.done": "Informe recibido. Lo revisaremos pronto.",
  "abuse.failed": "El envío falló. Vuelve a intentarlo más tarde.",
  "abuse.reason.spam": "Correo basura",
  "abuse.reason.impersonation": "Interpretación",
  "abuse.reason.abuse": "Acoso u odio",
  "abuse.reason.illegal": "Contenido ilegal",
  "abuse.reason.other": "Otro tema",
  "abuse.submitBusy": "Enviando...",
  "abuse.submit": "Enviar informe",
  "terms.title": "Términos de servicio",
  "privacy.title": "Aviso de privacidad",
  "validation.handle.required": "Introduce un identificador.",
  "validation.handle.invalid": "El identificador debe tener entre 4 y 24 letras minúsculas sin acentos.",
  "validation.handle.reserved": "Esta dirección pública no está disponible. Prueba con otra.",
  "validation.handle.unavailable": "Esta dirección pública no está disponible. Prueba con otra.",
  "validation.handle.frozen": "Esta dirección pública no está disponible. Prueba con otra.",
  "validation.handle.protected": "Esta dirección pública no está disponible. Prueba con otra.",
  "validation.handle.checkFailed": "No pudimos confirmar esta dirección.",
  "validation.handle.changeLimit": "Solo puedes cambiar la URL pública una vez cada 30 días.",
  "validation.displayName.required": "Indica un nombre o apodo.",
  "validation.identity.required": "Escribe una descripción de una línea.",
  "validation.tags.range": "Añade entre 1 y 5 etiquetas.",
  "validation.links.limit": "Puedes añadir hasta {limit} enlaces independientes.",
  "validation.links.empty": "Aún no hay enlaces. Puedes añadir un perfil social, una página de reservas o un medio de contacto.",
  "validation.input.tooLong": "El texto puede tener como máximo {limit} caracteres.",
  "validation.body.placeholder": "El texto todavía contiene {detail}. Sustitúyelo por contenido real o elimínalo.",
  "validation.body.oldTemplate": "la plantilla anterior",
  "validation.body.readingTime": "La lectura estimada es de {seconds} segundos. Redúcela a {maximum} segundos o menos.",
  "validation.body.readingTimeLong": "La lectura estimada es de {seconds} segundos, por encima de los {recommended} segundos recomendados, pero aún puedes publicar.",
  "validation.body.readingTimeShort": "La lectura estimada es de {seconds} segundos. Añade contenido hasta llegar al menos a {minimum} segundos.",
  "validation.markdown.h1": "No se admiten # encabezados a nivel de página",
  "validation.markdown.deepHeading": "### y títulos más profundos no son compatibles",
  "validation.markdown.image": "La sintaxis de la imagen no es compatible",
  "validation.markdown.codeBlock": "Los bloques de código no son compatibles",
  "validation.markdown.taskList": "Las listas de tareas no son compatibles",
  "validation.markdown.table": "Las tablas no son compatibles",
  "validation.markdown.footnote": "No se admiten notas a pie de página",
  "validation.markdown.html": "HTML y las incrustaciones no son compatibles",
  "validation.markdown.commentUnclosed": "Al comentario le falta el marcador de cierre -->",
  "validation.markdown.commentStrayClose": "Al comentario le falta el marcador de apertura <!--",
  "validation.markdown.commentNested": "Los comentarios <!-- --> no pueden anidarse",
  "validation.markdown.nestedHeading": "Los títulos de sección deben estar en la raíz del documento",
  "validation.markdown.setextHeading": "No se admiten títulos Setext",
  "validation.markdown.headingInline": "Los títulos de sección solo pueden contener texto sin formato",
  "validation.markdown.frontmatter": "No se admite frontmatter",
  "validation.markdown.indentedCode": "No se admiten bloques de código con sangría; usa un bloque delimitado",
  "validation.markdown.codeFenceUnclosed": "Falta el delimitador de cierre del bloque de código",
  "validation.markdown.codeLanguage": "La etiqueta de lenguaje admite 1–32 letras, números, _, + o -",
  "validation.markdown.listDepth": "Las listas admiten hasta tres niveles",
  "validation.markdown.tableSize": "Las tablas admiten hasta 6 columnas y 20 filas",
  "validation.markdown.linkProtocol": "Los enlaces del cuerpo solo admiten HTTPS y correo",
  "validation.link.unsupportedType": "Este tipo de enlace aún no está disponible. Elige un enlace a un sitio web, una plataforma o una página de reservas.",
  "validation.link.labelRequired": "El nombre del enlace no puede estar vacío.",
  "validation.link.providerRequired": "Elija una plataforma de reservas.",
  "validation.link.valueRequired": "{label} no puede estar vacío.",
  "validation.link.httpsOnly": "Los enlaces solo admiten https://.",
  "validation.link.invalid": "Ingrese un enlace válido.",
  "validation.link.validEmail": "Ingrese un correo electrónico válido.",
  "validation.link.validGithub": "Introduzca un identificador GitHub válido.",
  "validation.link.validBilibili": "Introduzca un Bilibili UID válido.",
  "validation.link.validXiaohongshu": "Ingrese un enlace de perfil de Xiaohongshu válido.",
  "validation.link.validGoogleCalendar": "Ingrese un enlace de reserva Google Calendar válido.",
  "validation.link.validMicrosoftBookings": "Ingrese un enlace Microsoft Bookings válido.",
  "validation.theme.proRequired": "La publicación de este tema requiere 30s Pro.",
  "validation.link.validHubSpot": "Ingrese un enlace HubSpot Meetings válido.",
  "validation.account.banned": "Esta cuenta no puede publicarse en este momento.",
  "validation.account.login": "Inicia sesión primero.",
  "validation.account.invite": "Activa primero tu cuenta con un código de invitación.",
  "validation.publish.failed": "La publicación falló. Vuelve a intentarlo más tarde.",
  "validation.turnstile.required": "Completa la verificación de seguridad.",
  "validation.report.missing": "Falta la página que quieres denunciar.",
  "validation.report.reason": "Elige un motivo para la denuncia.",
  "validation.report.notReportable": "Esta página no se puede denunciar en este momento.",
  "common.listSeparator": ",",
  "dashboard.section.status": "Estado",
  "dashboard.section.performance": "Rendimiento",
  "dashboard.fullAnalytics": "Ver análisis completos",
  "dashboard.shareCard": "compartir tarjeta",
  "dashboard.timestamp.notPublished": "No publicado",
  "dashboard.timestamp.notEdited": "No editado",
  "dashboard.timestamp.published": "Publicado {date} UTC",
  "dashboard.timestamp.edited": "Editado {date} UTC",
  "upgrade.publishTheme": "Publicar {theme}",
  "upgrade.copy": "Tu selección está guardada y puedes seguir previsualizándola por completo. Tras actualizar a Pro, podrás publicarla sin volver a editar.",
  "upgrade.benefit.themes": "Publica todos los temas premium",
  "upgrade.benefit.analytics": "Ver tiempo de lectura y finalización.",
  "upgrade.benefit.cards": "Tarjetas temáticas sincronizadas con OG social",
  "upgrade.seePro": "Ver 30s Pro",
  "upgrade.keepEditing": "Sigue editando",
  "pro.meta.title": "30s Pro: Exprésate",
  "pro.meta.description": "Temas premium, análisis de calidad de lectura y tarjetas para compartir que hacen que tu introducción de 30 segundos se sienta más personal.",
  "pro.title": "Exprésate a tu manera.",
  "pro.intro": "Se sigue leyendo en 30 segundos. Con Pro tienes más formas de expresarte, señales más claras y recursos listos para compartir.",
  "pro.priceAction": "Ver Precio Fundacional",
  "pro.summaryAria": "Resumen de ventajas de Pro",
  "pro.summaryThemes": "temas premium",
  "pro.summaryAnalytics": "días de análisis",
  "pro.summaryShare": "sincronizado con tu tarjeta",
  "pro.benefitsKicker": "Herramientas Pro",
  "pro.benefitsTitle": "De expresarte a llegar a los demás.",
  "pro.benefit.themes.title": "Temas premium",
  "pro.benefit.themes.body": "Ocho temas, con Terminal a la cabeza. Puedes probarlos todos gratis y publicarlos con Pro.",
  "pro.benefit.analytics.title": "Calidad de lectura",
  "pro.benefit.analytics.body": "Ve más allá de las visitas: tiempo de lectura activa, tasa de finalización, punto de abandono, tendencias de 30, 90 y 365 días y CTR de los enlaces.",
  "pro.benefit.share.title": "Comparte a tu manera",
  "pro.benefit.share.body": "Free incluye una tarjeta sencilla con nombre y enlace. Pro suma dos tarjetas universales y una propia para cada tema. La que elijas se usa como imagen OG e incluye un QR para compartirla o descargarla.",
  "pro.benefit.attribution.title": "Solo tú",
  "pro.benefit.attribution.body": "Oculta la firma de 30s.to dentro del tema sin perder funciones necesarias como la denuncia y el selector de idioma.",
  "pro.pricingTitle": "Cuanto antes llegues, más sencillo.",
  "pro.pricingBody": "Conservas el Founding Price mientras mantengas la suscripción. Si vuelves después de cancelarla, se aplicará el precio vigente.",
  "pro.terminalAria": "Vista previa del tema Terminal Pro",
  "pro.checkout.continuous": "Precio fijo mientras sigas",
  "pro.checkout.intervalAria": "Intervalo de facturación",
  "pro.checkout.monthly": "Mensual",
  "pro.checkout.yearly": "Anual",
  "pro.checkout.save": "Ahorra $16",
  "pro.checkout.periodYear": "año",
  "pro.checkout.periodMonth": "mes",
  "pro.checkout.annualNote": "Equivale a ${price} al mes: un 44% menos que el plan mensual.",
  "pro.checkout.monthlyNote": "Paga mes a mes y cancela cuando quieras al final del periodo.",
  "pro.checkout.includeThemes": "Todos los temas premium",
  "pro.checkout.includeAnalytics": "Calidad de lectura y análisis de 365 días",
  "pro.checkout.includeCards": "Tarjetas temáticas, QR y OG",
  "pro.checkout.includeAttribution": "Ocultar atribución dentro del tema",
  "pro.checkout.manage": "Gestionar mi Pro",
  "pro.checkout.comingSoon": "Pago disponible próximamente",
  "pro.checkout.signIn": "Inicia sesión para mejorar",
  "pro.checkout.inviteRequired": "Necesitas una invitación Beta",
  "pro.checkout.opening": "Abriendo pago seguro...",
  "pro.checkout.upgrade": "Actualiza a 30s Pro",
  "pro.checkout.footnote": "Pago seguro con Creem. Verás los impuestos antes de pagar; no hay prueba gratuita y la suscripción se renueva automáticamente.",
  "pro.checkout.unavailable": "No podemos abrir el pago ahora. Inténtalo de nuevo más tarde.",
  "pro.checkout.networkError": "No se ha podido conectar. Inténtalo de nuevo más tarde.",
  "billing.panelAria": "Pro y facturación",
  "billing.plan": "Plan",
  "billing.status.canceling": "Cancelación programada",
  "billing.status.pastDue": "Pago pendiente",
  "billing.status.active": "Activo",
  "billing.status.free": "Gratis",
  "billing.yearly": "Anual",
  "billing.monthly": "Mensual",
  "billing.basicPlan": "Plan gratuito",
  "billing.ends": "Termina {date}",
  "billing.renews": "Renueva {date}",
  "billing.graceEnds": "Finaliza el periodo de gracia: {date}",
  "billing.anomaly": "Su estado de facturación necesita una revisión manual. Póngase en contacto con support@30s.to.",
  "billing.opening": "Abriendo la gestión de pagos",
  "billing.manage": "Facturación",
  "billing.upgrade": "Actualízate a Pro",
  "billing.openingHistory": "Abriendo…",
  "billing.viewHistory": "Ver historial de facturación",
  "billing.portalUnavailable": "La gestión de facturación no está disponible temporalmente.",
  "billing.networkError": "La conexión de red falló. Por favor inténtalo de nuevo.",
  "billingReturn.kicker": "30s Pro · Confirmación segura",
  "billingReturn.activeTitle": "Pro ya está activo",
  "billingReturn.failedTitle": "El pago aún no está confirmado",
  "billingReturn.waitingTitle": "Confirmando tu pago",
  "billingReturn.failedCopy": "Es posible que su pago aún se esté sincronizando. Consulte el Panel nuevamente más tarde; El acceso nunca se otorga únicamente desde la página de retorno.",
  "billingReturn.waitingCopy": "Estamos verificando su suscripción con el proveedor de pagos. Mantenga esta página abierta.",
  "billingReturn.back": "Volver al panel",
  "analytics.kicker": "30s Pro · Análisis",
  "analytics.nav": "Análisis",
  "analytics.title": "De la visita a la lectura completa.",
  "analytics.copy": "Sigue el recorrido desde la visita hasta la lectura completa y los clics, sin rastrear a las personas. Las fechas y la deduplicación usan UTC.",
  "analytics.rangeAria": "Rango de fechas",
  "analytics.days": "{count} días",
  "analytics.uniqueVisitors": "Visitantes únicos",
  "analytics.rangeTotal": "Total de {count} días",
  "analytics.averageReading": "Tiempo medio de lectura activa",
  "analytics.activeReadingNote": "Tiempo visible y enfocado",
  "analytics.completionRate": "Tasa de finalización",
  "analytics.completedVisitors": "{count} visitantes completaron la lectura",
  "analytics.overallCtr": "CTR general",
  "analytics.engagedVisitors": "{count} visitantes interactuaron",
  "analytics.trafficTrend": "Tendencia del tráfico",
  "analytics.dailyTrendAria": "Tendencia diaria de visitantes únicos",
  "analytics.readingCompletion": "Finalización de lectura",
  "analytics.dailyMaximum": "Visitantes / máximo diario",
  "analytics.visitorCount": "Visitantes {count}",
  "analytics.topLinks": "Enlaces principales",
  "analytics.uniqueClickers": "Personas que hicieron clic",
  "analytics.linkTrendAria": "Tendencia diaria de {label}",
  "analytics.noInteractions": "Aún no hay interacciones de enlaces.",
  "analytics.audienceOverview": "Descripción general de la audiencia",
  "analytics.pageLevel": "Nivel de página",
  "analytics.referrers": "Fuentes de tráfico",
  "analytics.devices": "Dispositivos",
  "analytics.countries": "Países",
  "analytics.noData": "Aún no hay datos",
  "analytics.durationSeconds": "{seconds} s",
  "analytics.durationMinutes": "{minutes} min {seconds} s",
  "share.card": "Tarjeta para compartir",
  "share.variant.classic": "Clásico",
  "share.variant.classicNote": "Tranquilo",
  "share.variant.contact": "índice",
  "share.variant.contactNote": "estructurado",
  "share.variant.theme": "Edición {theme}",
  "share.variant.themeNote": "Tema",
  "share.variant.universal": "Universales",
  "share.saveFailed": "No se pudo guardar",
  "share.styleUpdated": "Estilo actualizado",
  "share.networkError": "La conexión de red falló",
  "share.linkCopied": "Enlace copiado",
  "share.copyFailed": "Copia fallida",
  "share.text": "Mi introducción de 30 segundos",
  "share.failed": "No se pudo compartir",
  "share.published": "Publicado",
  "share.draft": "Borrador",
  "share.style": "Estilo",
  "share.alt": "Tarjeta compartida de {name}",
  "share.publishFirst": "Publicar para compartir",
  "share.action": "Compartir",
  "share.download": "Descargar",
  "share.openPublicPage": "Abrir página pública",
  "share.chooseStyle": "Elige el estilo de la tarjeta",
  "share.close": "Cerrar",
  "share.cardStyle": "Estilo de tarjeta",
  "share.chooseOne": "Elige un estilo",
  "share.chooseStyleAria": "Elija el estilo de la tarjeta compartida",
  "share.saving": "Guardando",
  "validation.body.placeholderDetail.legacyTemplate": "la plantilla de texto anterior",
  "validation.body.placeholderDetail.ellipsis": "el marcador de posición `...`",
  "validation.body.placeholderDetail.sampleLink": "el enlace de muestra `https://example.com`",
  "validation.body.placeholderDetail.projectName": "el marcador de posición `项目名`",
  "validation.body.placeholderDetail.instruction": "texto de instrucciones de la plantilla",
  "analytics.gate.signInTitle": "Inicia sesión para ver las analíticas",
  "analytics.gate.signInCopy": "Tus datos de visitas e interacciones se guardan de forma segura en el panel.",
  "analytics.gate.signInAction": "Iniciar sesión",
  "analytics.gate.proTitle": "Descubre si leen tu presentación hasta el final.",
  "analytics.gate.proCopy": "Consulta el tiempo de lectura activo, la tasa de finalización, la distribución del progreso, las tendencias de 30, 90 y 365 días y el CTR de los enlaces.",
  "analytics.gate.proAction": "Ver 30s Pro",
  "analytics.gate.emptyTitle": "Tus datos aparecerán después de publicar.",
  "analytics.gate.emptyCopy": "Termina primero tu presentación de 30 segundos. Después de publicarla, podrás ver las tendencias de visitas e interacciones.",
  "analytics.gate.emptyAction": "Empezar a crear",
  "analytics.gate.privacyNote": "Agregación diaria en UTC · Deduplicación anónima · No se guarda la IP original",
  "handleEdit.previous": "Direcciones anteriores protegidas",
  "handleEdit.deadlines": "Redirección hasta {redirectDate}; protección hasta {releaseDate}.",
  "handleEdit.usePrevious": "Usar esta dirección",
  "handleEdit.reclaimAvailable": "Puedes recuperar esta dirección anterior.",
  "publish.handleReclaimed": "Recuperarla cuenta como un cambio de dirección. La dirección actual iniciará otros 30 días de redirección y 180 días de protección."
}
